import React, { useEffect, useState} from "react";
import DataTable from "react-data-table-component";
import { Button, Card, Row, Col, Form, Spinner } from "react-bootstrap";
import KapalService from "../../services/master/KapalService.js";
import AddPelabuhanModal from "./PelabuhanPendaratanModal.js";

const PelabuhanPendaratan = () => {
  const [searchKeyword, setSearchKeyword] = useState("");
  const [Pelabuhan, setPelabuhan] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [showAddModal, setShowAddModal] = useState(false);

const fetchPelabuhan = async () => {
  try {
    setLoading(true);
    const response = await KapalService.getPelabuhan(currentPage, perPage, searchKeyword);
    setPelabuhan(response.data || []);
    setTotalRows(response.totalRows || 0);
  } catch (err) {
    console.error("Gagal ambil data pelabuhan:", err);
    setPelabuhan([]);
    setTotalRows(0);
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  fetchPelabuhan();
}, [currentPage, perPage, searchKeyword]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  const handleReset = () => {
    setSearchKeyword("");
  };

  // Kolom tabel utama
const columnsPelabuhan = [

  { 
    name: "Nama Pelabuhan Pendaratan", 
    selector: (row) => row.nama_pelabuhan || "-",
    wrap: true 
  },
  { 
    name: "Kode Pelabuhan", 
    selector: (row) => row.kode_pelabuhan || "-",
    wrap: true 
  },
    { 
    name: "Propinsi", 
    selector: (row) => row.URAIAN_PROPINSI|| "-",
    wrap: true 
  },
  { 
  name: "Koordinat", 
  selector: (row) => row.koordinat || "-",
  cell: (row) => {
    if (!row.koordinat) return "-";
       return (
      <a
        href={`https://www.google.com/maps?q=${row.koordinat}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {row.koordinat}
      </a>
    );
  },
  wrap: true 
},
  { 
    name: "Lokasi Pelabuhan", 
    selector: (row) => row.lokasi_pelabuhan || "-",
    wrap: true 
  },
  { 
    name: "Jenis Pelabuhan", 
    selector: (row) => row.jenis_pelabuhan || "-",
    wrap: true 
  },
  ];

   return (
    <Row>
      <Col sm="12">
        {/* Pencarian */}
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Pencarian Data</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <Form>
              <Row className="align-items-end">
                <Col sm="3">
                  <Form.Group>
                    <Form.Control
                      type="text"
                      placeholder="Cari disini..."
                      value={searchKeyword}
                      onChange={(e) => setSearchKeyword(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col sm="2">
                  <Button variant="secondary" className="w-100" onClick={handleReset}>
                    Reset
                  </Button>
                </Col>
              </Row>
              <Row className="mt-3">
              <div>
              <Button onClick={() => setShowAddModal(true)}>+ Tambah Pelabuhan</Button>
                      <AddPelabuhanModal
                  show={showAddModal}
                  onHide={() => setShowAddModal(false)}
                  onSuccess={fetchPelabuhan}
                />
            </div>
            </Row>
            </Form>
          </Card.Body>
        </Card>

        {/* Data Pelabuhan Pendaratan */}
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Daftar Pelabuhan Pendaratan</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className="table-responsive border-bottom ">
              {loading ? (
                <Spinner animation="border" />
              ) : (
                <DataTable
                columns={columnsPelabuhan}
                data={Pelabuhan}
                pagination
                paginationServer
                paginationTotalRows={totalRows} 
                paginationDefaultPage={currentPage}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                progressPending={loading}
                progressComponent={
                  <div className="text-center my-3">
                    <Spinner animation="border" /> Loading data...
                  </div>
                }
                noDataComponent="Tidak ada data Pelabuhan Pendaratan"
                customStyles={{
                        headCells: {
                          style: {
                            backgroundColor: "#00acee",
                            color: "white",
                          },
                        },
                        cells: {
                          style: {
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            fontSize: '14px',
                          },
                        },
                        rows: {
                          style: {
                            minHeight: '60px',
                          },
                        },
                      }}
                />
              )}
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default PelabuhanPendaratan;
